<div class="test-theme-container">
  <div class="test-theme-title" translate="PRESENTER.TEST_THEME.TITLE"></div>
  <div class="test-theme-description" translate="PRESENTER.TEST_THEME.DESCRIPTION"></div>

  <div class="test-theme-colors">
    @for (item of colorTokens; track item.token) {
      <div class="test-theme-color-row">
        <gb-color-picker
          [labelTranslateKey]="item.labelTranslateKey"
          [control]="item.control"
          cpPosition="right"
          circleDiameter="38px"
          (colorChange)="onColorChange(item.token, $event)"
        ></gb-color-picker>
      </div>
    }
  </div>
</div>
